// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'cloud-solid';

export const Component = () => (
  <path d='M21.828 9.647c1.15 1.15 1.724 2.538 1.724 4.166 0 1.628-.575 3.017-1.724 4.167-1.15 1.149-2.538 1.724-4.166 1.724H8.849c-1.915-.144-3.544-.958-4.837-2.347C2.672 15.968 2 14.292 2 12.328c0-2.012.719-3.736 2.155-5.173C5.545 5.72 7.27 5 9.328 5c2.635 0 4.694 1.102 6.178 3.305a6.38 6.38 0 0 1 2.156-.383c1.628 0 3.017.575 4.166 1.724Z' />
);

export const viewBox = '0 0 25 25';
